import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageLoader from "@/components/base/PageLoader";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
}